"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaIcon = _interopRequireWildcard(require("@thinkific/toga-icon"));

var _Button = _interopRequireDefault(require("./Button"));

var _Button2 = _interopRequireDefault(require("./Button.css"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_Button2["default"]);

var IconButton = function IconButton(_ref) {
  var className = _ref.className,
      isSmall = _ref.isSmall,
      name = _ref.name,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["className", "isSmall", "name", "title"]);

  var classes = cx({
    'button--icon-only': !isSmall,
    'button--icon-only-small': isSmall
  }, className);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    "aria-label": title,
    className: classes
  }, props), name && /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    name: name,
    title: title,
    "aria-hidden": true
  }));
};

IconButton.propTypes = {
  /** CSS classes */
  className: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),
  isSmall: _propTypes["default"].bool,
  name: _propTypes["default"].oneOf(_togaIcon.availableIcons).isRequired,
  title: _propTypes["default"].string.isRequired
};
IconButton.defaultProps = {
  className: null,
  isSmall: false
};
var _default = IconButton;
exports["default"] = _default;